/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'base-grade': {
    width: 16,
    height: 15.727,
    viewBox: '0 0 16 15.727',
    data: '<path pid="0" d="M.75 15.727L2.5 7.113a1.036 1.036 0 011-1.067H15a1.034 1.034 0 011 1.065l-1.747 7.55a1.037 1.037 0 01-1 1.066zm4.69-2.884v.735a.245.245 0 00.245.246h5.381a.245.245 0 00.245-.246v-.742c0-.961-1.911-1.464-2.935-1.464s-2.936.505-2.936 1.471zm2.844-4.891a1.49 1.49 0 00-1.38 1.367 1.469 1.469 0 00.4 1.111 1.45 1.45 0 001.068.464 1.472 1.472 0 001.471-1.471 1.449 1.449 0 00-.424-1.039 1.462 1.462 0 00-1.046-.436zM0 1a1.034 1.034 0 011.06-1h5.292a1.034 1.034 0 011.06 1v.905h6.352a1.034 1.034 0 011.06 1v1.971H2.779c-1.03-.034-1.34 1.224-1.34 1.774L0 14.412z" _fill="#212121"/>'
  }
})
